import { render } from "./AuthorizedColLayout.vue?vue&type=template&id=787bb0fe"
import script from "./AuthorizedColLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizedColLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__